module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.type == 'hasol') ? _c('ul', {
    staticClass: "list-group note"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("您今天共有" + _vm._s(_vm.data.length) + "条待办事宜")])]), _vm._v(" "), _vm._l((_vm.data), function(list, index) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_c('span', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(list.time))]), _vm._v(" "), _c('span', {
      staticClass: "label",
      class: _vm._f("setState")(list.state)
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" " + _vm._s(list.title) + "\n\t")])
  })], true) : _c('ul', {
    staticClass: "list-group note"
  }, _vm._l((_vm.data), function(list, index) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_c('span', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(list.time))]), _vm._v(" "), _c('span', {
      staticClass: "label",
      class: _vm._f("setState")(list.state)
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" " + _vm._s(list.title) + "\n\t")])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-62e7d62d!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/comp/notes/note.vue
// module id = 319
// module chunks = 2